import React from 'react';

function Reconciliation() {
  return (
    <div>
      <div className="startinventoryOuter">
        <div className="startinventory">
          <h4>Reconciliation</h4>
        </div>
      </div>
    </div>
  )
}

export default Reconciliation;
